import { createSlice } from '@reduxjs/toolkit';

export const giftCardSlice = createSlice({
  name: 'giftCard',
  initialState: {
    pendingGiftCards: [],
  },
  reducers: {
    addCard: (state, action) => {
      state.pendingGiftCards.push(action.payload);
    },
    resetCards: (state) => {
      state.pendingGiftCards = [];
    },
  },
});

export const { addCard, resetCards } = giftCardSlice.actions;
export default giftCardSlice.reducer;
